export const colorPalette = {
  // background: "#0A0A0A",
  // textActive: "#FFFFFF",
  // divider: "#ddd",
  // dividerStrong: "#ccc",
  // textLight: "#efefef",
  // accent: "#a66f2c",
  // backgroundLight: "#222",
  // backgroundMedium: "#333",

  text: "#202020",
  textDark: "#101010",
  error: "#dd6565",
  border: "#404040",
  textPlaceholder: "#9f9f9f",
  white: "#fff",
  black: "#000",
  transparent: "#00000000",
};
